/**
 * This file specifies the state of the application in response to Basic Registration actions
 */

import { get, isEqual, lowerCase } from 'lodash';
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { Auth } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  validAccessToken: false,
  token: null,
});

/**
 * Validates the access token input
 *
 * @param {string} provided the access token input
 * @param {string} token the access token to match against the input
 */
const matchToken = (provided, tokenRecord) =>
  isEqual(lowerCase(provided), lowerCase(get(tokenRecord, 'token')));

/**
 * Returns and sets the next state based on the action passed to it
 *
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const basicRegistrationReducer = (state = initialState, action) => {
  const { token, retrievedToken } = action;

  switch (action.type) {
    case Auth.SIGNUP:
      return state.set('loading', true).set('error', null);
    case Auth.SIGNUP_ERROR:
      return state
        .set('loading', false)
        .set('error', get(action, 'error.message'));
    case Auth.SIGNUP_SUCCESS:
      return state.set('loading', false).set('error', null);
    case Auth.VERIFY_INVITE_TOKEN:
      return state.set('loading', true);
    case Auth.VERIFY_INVITE_TOKEN_ERROR:
      return state
        .set('error', get(action, 'error.message'))
        .set('loading', false);
    case Auth.VERIFY_INVITE_TOKEN_SUCCESS:
      return state
        .set('validAccessToken', matchToken(token, retrievedToken))
        .set(
          'token',
          !matchToken(token, retrievedToken) ? null : retrievedToken,
        )
        .set('loading', false)
        .set('error', null);
    default:
      return state;
  }
};

export default basicRegistrationReducer;
